import { Injectable, inject } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CountriesService } from '../services/countries/countries.service';

/**
 * Resolver to fetch all countries
 */
@Injectable()
export class CountriesResolver {
  private readonly countriesService = inject(CountriesService);
  private readonly translateService = inject(TranslateService);


  resolve() {
    return this.countriesService
      .getCountries(this.getCurrentLanguage())
      .pipe(catchError((err) => of([])));
  }

  /***
   * Get currently used (or a default) language
   */
  private getCurrentLanguage(): number {
    // find active language
    let currentLang = 1; // set 1 as default

    // if a currentlang was set in the translate service; language should be formatted as e.g.: 'client_1', 'public_3'
    if (
      this.translateService.currentLang !== undefined &&
      this.translateService.currentLang !== null &&
      this.translateService.currentLang.split('_').length === 2
    ) {
      const cLang = Number(this.translateService.currentLang.split('_')[1]);
      if (!isNaN(cLang)) {
        currentLang = cLang;
      }
    } else {
      // if the defaultlang was set in the translate service; language should be formatted as e.g.: 'client_1', 'public_3'
      if (
        this.translateService.defaultLang !== undefined &&
        this.translateService.defaultLang !== null &&
        this.translateService.defaultLang.split('_').length === 2
      ) {
        const cLang = Number(this.translateService.defaultLang.split('_')[1]);
        if (!isNaN(cLang)) {
          currentLang = cLang;
        }
      }
    }

    return currentLang;
  }
}
